
import React, { useState, useEffect } from "react";

// reactstrap components
import {
    Button,
    Container,
    Row,
    Col,
    Card,
    CardBody,
} from "reactstrap";

// core components
import ExamplesNavbar from "components/Navbars/ExamplesNavbar.js";
import NFCHeader from "components/Headers/NFCHeader.js";
import DemoFooter from "components/Footers/DemoFooter.js";

function NFC() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        document.body.classList.add("profile-page");
        setIsVisible(true);
        return function cleanup() {
            document.body.classList.remove("profile-page");
        };
    }, []);

    return (
        <>
            <ExamplesNavbar />
            <NFCHeader />

            {/* Hero Section */}
            <div style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                padding: '100px 0',
                position: 'relative',
                overflow: 'hidden'
            }}>
                {/* Animated Background Elements */}
                <div style={{
                    position: 'absolute',
                    top: '10%',
                    left: '5%',
                    width: '200px',
                    height: '200px',
                    background: 'rgba(255,255,255,0.1)',
                    borderRadius: '50%',
                    animation: 'float 6s ease-in-out infinite'
                }}></div>
                
                <div style={{
                    position: 'absolute',
                    bottom: '15%',
                    right: '8%',
                    width: '150px',
                    height: '150px',
                    background: 'rgba(255,255,255,0.05)',
                    borderRadius: '50%',
                    animation: 'float 8s ease-in-out infinite 2s'
                }}></div>

                <Container style={{ position: 'relative', zIndex: 2 }}>
                    <Row>
                        <Col className="text-center">
                            <div style={{
                                opacity: isVisible ? 1 : 0,
                                transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
                                transition: 'all 1s ease-out'
                            }}>
                                <h1 style={{
                                    color: 'white',
                                    fontSize: '4rem',
                                    fontWeight: '700',
                                    marginBottom: '30px',
                                    textShadow: '0 4px 10px rgba(0,0,0,0.4)'
                                }}>
                                    📱 Next-Gen Business Cards
                                </h1>
                                
                                <h2 style={{
                                    color: '#feca57',
                                    fontSize: '2.5rem',
                                    fontWeight: '600',
                                    marginBottom: '40px',
                                    textShadow: '0 2px 6px rgba(0,0,0,0.3)'
                                }}>
                                    NFC & NFC Golden Cards
                                </h2>

                                <p style={{
                                    color: 'rgba(255,255,255,0.9)',
                                    fontSize: '1.4rem',
                                    maxWidth: '800px',
                                    margin: '0 auto 50px',
                                    lineHeight: '1.8',
                                    textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                                }}>
                                    Transform your networking with cutting-edge NFC technology. 
                                    Share your entire digital presence with just one tap!
                                </p>

                                <Button
                                    className="btn-round"
                                    style={{
                                        background: 'linear-gradient(45deg, #ff6b6b, #feca57)',
                                        border: 'none',
                                        padding: '20px 50px',
                                        borderRadius: '35px',
                                        color: 'white',
                                        fontWeight: '700',
                                        fontSize: '1.3rem',
                                        boxShadow: '0 10px 30px rgba(255, 107, 107, 0.4)',
                                        transition: 'all 0.3s ease',
                                        marginRight: '20px'
                                    }}
                                    href="https://api.whatsapp.com/send/?phone=%2B96181906656&text&type=phone_number&app_absent=0"
                                    target="_blank"
                                >
                                    <i className="fa fa-whatsapp" style={{ marginRight: '10px' }} />
                                    Order Now
                                </Button>

                                <Button
                                    className="btn-round"
                                    style={{
                                        background: 'rgba(255,255,255,0.2)',
                                        backdropFilter: 'blur(10px)',
                                        border: '2px solid white',
                                        padding: '20px 50px',
                                        borderRadius: '35px',
                                        color: 'white',
                                        fontWeight: '700',
                                        fontSize: '1.3rem',
                                        boxShadow: '0 10px 30px rgba(255, 255, 255, 0.2)',
                                        transition: 'all 0.3s ease'
                                    }}
                                    href="#features"
                                >
                                    Learn More
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/* Features Section */}
            <div id="features" style={{
                background: 'white',
                padding: '120px 0',
                position: 'relative'
            }}>
                    <Container>
                        <Row>
                        <Col className="text-center" style={{ marginBottom: '80px' }}>
                            <h2 style={{
                                color: '#333',
                                fontSize: '3.5rem',
                                fontWeight: '700',
                                marginBottom: '30px'
                            }}>
                                Why Choose NFC Cards?
                            </h2>
                            <div style={{
                                width: '100px',
                                height: '5px',
                                background: 'linear-gradient(90deg, #667eea, #764ba2)',
                                margin: '0 auto 40px',
                                borderRadius: '3px'
                            }}></div>
                            <p style={{
                                color: '#666',
                                fontSize: '1.3rem',
                                maxWidth: '700px',
                                margin: '0 auto',
                                lineHeight: '1.8'
                            }}>
                                Experience the future of business networking with our premium NFC technology
                            </p>
                        </Col>
                    </Row>

                    <Row>
                        <Col md="4" style={{ marginBottom: '40px' }}>
                            <div style={{
                                textAlign: 'center',
                                padding: '40px 30px',
                                background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                                borderRadius: '25px',
                                color: 'white',
                                boxShadow: '0 15px 35px rgba(240, 147, 251, 0.3)',
                                transition: 'all 0.3s ease',
                                height: '100%'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-10px)';
                                e.currentTarget.style.boxShadow = '0 25px 50px rgba(240, 147, 251, 0.4)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 15px 35px rgba(240, 147, 251, 0.3)';
                            }}>
                                <div style={{
                                    fontSize: '4rem',
                                    marginBottom: '25px'
                                }}>
                                    ⚡
                                </div>
                                <h3 style={{
                                    fontSize: '1.8rem',
                                    fontWeight: '600',
                                    marginBottom: '20px'
                                }}>
                                    Instant Sharing
                                </h3>
                                <p style={{
                                    fontSize: '1.1rem',
                                    lineHeight: '1.7',
                                    opacity: '0.9'
                                }}>
                                    Share your entire digital profile with just one tap. No more fumbling with multiple apps or typing contact details.
                                </p>
                            </div>
                        </Col>

                        <Col md="4" style={{ marginBottom: '40px' }}>
                            <div style={{
                                textAlign: 'center',
                                padding: '40px 30px',
                                background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                                borderRadius: '25px',
                                color: 'white',
                                boxShadow: '0 15px 35px rgba(79, 172, 254, 0.3)',
                                transition: 'all 0.3s ease',
                                height: '100%'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-10px)';
                                e.currentTarget.style.boxShadow = '0 25px 50px rgba(79, 172, 254, 0.4)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 15px 35px rgba(79, 172, 254, 0.3)';
                            }}>
                                <div style={{
                                    fontSize: '4rem',
                                    marginBottom: '25px'
                                }}>
                                    💎
                                </div>
                                <h3 style={{
                                    fontSize: '1.8rem',
                                    fontWeight: '600',
                                    marginBottom: '20px'
                                }}>
                                    Premium Materials
                                </h3>
                                <p style={{
                                    fontSize: '1.1rem',
                                    lineHeight: '1.7',
                                    opacity: '0.9'
                                }}>
                                    Choose from Metal (Gold, Black, Titanium), PVC, or organic Bamboo. Each card is crafted to perfection for lasting impressions.
                                </p>
                            </div>
                        </Col>

                        <Col md="4" style={{ marginBottom: '40px' }}>
                            <div style={{
                                textAlign: 'center',
                                padding: '40px 30px',
                                background: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
                                borderRadius: '25px',
                                color: 'white',
                                boxShadow: '0 15px 35px rgba(67, 233, 123, 0.3)',
                                transition: 'all 0.3s ease',
                                height: '100%'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-10px)';
                                e.currentTarget.style.boxShadow = '0 25px 50px rgba(67, 233, 123, 0.4)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 15px 35px rgba(67, 233, 123, 0.3)';
                            }}>
                                <div style={{
                                    fontSize: '4rem',
                                    marginBottom: '25px'
                                }}>
                                    🔄
                                </div>
                                <h3 style={{
                                    fontSize: '1.8rem',
                                    fontWeight: '600',
                                    marginBottom: '20px'
                                }}>
                                    Update Anytime
                                </h3>
                                <p style={{
                                    fontSize: '1.1rem',
                                    lineHeight: '1.7',
                                    opacity: '0.9'
                                }}>
                                    Never print new cards again! Update your information, social media, website, and contact details instantly through our platform.
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/* Cards Showcase Section */}
            <div style={{
                background: 'linear-gradient(135deg, #7C3AED 0%, #EC4899 100%)',
                padding: '120px 0',
                position: 'relative',
                overflow: 'hidden'
            }}>
                                        <Container>
                    <Row>
                        <Col className="text-center" style={{ marginBottom: '80px' }}>
                            <h2 style={{
                                color: 'white',
                                fontSize: '3.5rem',
                                fontWeight: '700',
                                marginBottom: '30px',
                                textShadow: '0 4px 8px rgba(0,0,0,0.3)'
                            }}>
                                Our Premium Collection
                            </h2>
                            <div style={{
                                width: '120px',
                                height: '5px',
                                background: 'linear-gradient(90deg, #ff6b6b, #feca57)',
                                margin: '0 auto 40px',
                                borderRadius: '3px'
                            }}></div>
                            <p style={{
                                color: 'rgba(255,255,255,0.9)',
                                fontSize: '1.3rem',
                                maxWidth: '700px',
                                margin: '0 auto',
                                lineHeight: '1.8'
                            }}>
                                Choose from our range of sophisticated NFC business cards, each designed to make a lasting impression
                            </p>
                        </Col>
                    </Row>

                                            <Row>
                        <Col md="6" style={{ marginBottom: '50px' }}>
                            <Card style={{
                                background: 'rgba(255,255,255,0.1)',
                                backdropFilter: 'blur(15px)',
                                borderRadius: '25px',
                                border: '2px solid rgba(255,255,255,0.2)',
                                overflow: 'hidden',
                                transition: 'all 0.4s ease'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-15px) scale(1.02)';
                                e.currentTarget.style.boxShadow = '0 25px 50px rgba(0,0,0,0.3)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0) scale(1)';
                                e.currentTarget.style.boxShadow = 'none';
                            }}>
                                <CardBody style={{ padding: '40px' }}>
                                    <div style={{
                                        textAlign: 'center',
                                        marginBottom: '30px'
                                    }}>
                                        <h3 style={{
                                            color: 'white',
                                            fontSize: '2.5rem',
                                            fontWeight: '600',
                                            marginBottom: '20px',
                                            textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                                        }}>
                                            📱 Standard NFC
                                        </h3>
                                        <div style={{
                                            width: '200px',
                                            height: '200px',
                                            margin: '0 auto',
                                            borderRadius: '15px',
                                            overflow: 'hidden',
                                            boxShadow: '0 15px 30px rgba(0,0,0,0.3)',
                                            border: '3px solid rgba(255,255,255,0.3)'
                                        }}>
                                            <img
                                                alt="Standard NFC Card"
                                                        src={require("assets/img/nfc2.jpg").default}
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover'
                                                }}
                                                    />
                                                        </div>
                                                    </div>
                                    <p style={{
                                        color: 'rgba(255,255,255,0.9)',
                                        fontSize: '1.2rem',
                                        lineHeight: '1.8',
                                        textAlign: 'center',
                                        marginBottom: '30px'
                                    }}>
                                        Professional NFC business cards with premium materials. Perfect for everyday networking and business interactions.
                                    </p>
                                    <ul style={{
                                        color: 'rgba(255,255,255,0.9)',
                                        fontSize: '1.1rem',
                                        lineHeight: '2',
                                        paddingLeft: '20px'
                                    }}>
                                        <li>Multiple material options</li>
                                        <li>Instant contact sharing</li>
                                        <li>Social media integration</li>
                                        <li>Professional design</li>
                                    </ul>
                                </CardBody>
                            </Card>
                                                </Col>

                        <Col md="6" style={{ marginBottom: '50px' }}>
                            <Card style={{
                                background: 'linear-gradient(135deg, rgba(255,215,0,0.2), rgba(255,165,0,0.2))',
                                backdropFilter: 'blur(15px)',
                                borderRadius: '25px',
                                border: '2px solid rgba(255,215,0,0.4)',
                                overflow: 'hidden',
                                transition: 'all 0.4s ease'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-15px) scale(1.02)';
                                e.currentTarget.style.boxShadow = '0 25px 50px rgba(255,215,0,0.3)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0) scale(1)';
                                e.currentTarget.style.boxShadow = 'none';
                            }}>
                                <CardBody style={{ padding: '40px' }}>
                                    <div style={{
                                        textAlign: 'center',
                                        marginBottom: '30px'
                                    }}>
                                        <h3 style={{
                                            color: 'white',
                                            fontSize: '2.5rem',
                                            fontWeight: '600',
                                            marginBottom: '20px',
                                            textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                                        }}>
                                            👑 NFC Golden
                                        </h3>
                                        <div style={{
                                            width: '200px',
                                            height: '200px',
                                            margin: '0 auto',
                                            borderRadius: '15px',
                                            overflow: 'hidden',
                                            boxShadow: '0 15px 30px rgba(0,0,0,0.3)',
                                            border: '3px solid rgba(255,215,0,0.6)'
                                        }}>
                                            <img
                                                alt="Golden NFC Card"
                                                        src={require("assets/img/nfc1.jpg").default}
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover'
                                                }}
                                                    />
                                                        </div>
                                                    </div>
                                    <p style={{
                                        color: 'rgba(255,255,255,0.9)',
                                        fontSize: '1.2rem',
                                        lineHeight: '1.8',
                                        textAlign: 'center',
                                        marginBottom: '30px'
                                    }}>
                                        Luxury golden NFC cards for the ultimate in professional networking. Make a statement that lasts.
                                    </p>
                                    <ul style={{
                                        color: 'rgba(255,255,255,0.9)',
                                        fontSize: '1.1rem',
                                        lineHeight: '2',
                                        paddingLeft: '20px'
                                    }}>
                                        <li>Premium golden finish</li>
                                        <li>Luxury materials</li>
                                        <li>VIP networking experience</li>
                                        <li>Exclusive design options</li>
                                    </ul>
                                </CardBody>
                            </Card>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>

            {/* Call to Action Section */}
            <div style={{
                background: 'white',
                padding: '120px 0',
                textAlign: 'center'
            }}>
                <Container>
                    <Row>
                        <Col>
                            <h2 style={{
                                color: '#333',
                                fontSize: '3.5rem',
                                fontWeight: '700',
                                marginBottom: '30px'
                            }}>
                                Ready to Transform Your Networking?
                            </h2>
                            <p style={{
                                color: '#666',
                                fontSize: '1.4rem',
                                maxWidth: '700px',
                                margin: '0 auto 50px',
                                lineHeight: '1.8'
                            }}>
                                Join thousands of professionals who have already upgraded to NFC technology. 
                                Order your custom NFC business cards today and experience the future of networking!
                            </p>
                            
                            <div style={{ display: 'flex', justifyContent: 'center', gap: '30px', flexWrap: 'wrap' }}>
                                <Button
                                    className="btn-round"
                                    style={{
                                        background: 'linear-gradient(45deg, #25D366, #128C7E)',
                                        border: 'none',
                                        padding: '20px 50px',
                                        borderRadius: '35px',
                                        color: 'white',
                                        fontWeight: '700',
                                        fontSize: '1.3rem',
                                        boxShadow: '0 10px 30px rgba(37, 211, 102, 0.4)',
                                        transition: 'all 0.3s ease'
                                    }}
                                    href="https://api.whatsapp.com/send/?phone=%2B96181906656&text&type=phone_number&app_absent=0"
                                    target="_blank"
                                >
                                    <i className="fa fa-whatsapp" style={{ marginRight: '10px' }} />
                                    Order via WhatsApp
                                </Button>

                                <Button
                                    className="btn-round"
                                    style={{
                                        background: 'linear-gradient(45deg, #667eea, #764ba2)',
                                        border: 'none',
                                        padding: '20px 50px',
                                        borderRadius: '35px',
                                        color: 'white',
                                        fontWeight: '700',
                                        fontSize: '1.3rem',
                                        boxShadow: '0 10px 30px rgba(102, 126, 234, 0.4)',
                                        transition: 'all 0.3s ease'
                                    }}
                                    href="#contact"
                                >
                                    <i className="fa fa-envelope" style={{ marginRight: '10px' }} />
                                    Get Quote
                </Button>
                            </div>
                            </Col>
                        </Row>
                    </Container>
            </div>

            {/* Add keyframes for animations */}
            <style>{`
                @keyframes float {
                    0%, 100% { transform: translateY(0) translateX(0); }
                    25% { transform: translateY(-20px) translateX(10px); }
                    50% { transform: translateY(-10px) translateX(-10px); }
                    75% { transform: translateY(-30px) translateX(5px); }
                }
            `}</style>

            <DemoFooter />
        </>
    );
}

export default NFC;
